export const USER_DEFINED = "user_defined";
export const EXPERIENCE_MASONRY = "MASONRY";
export const EXPERIENCE_CAROUSEL = "CAROUSEL";
export const EXPERIENCE_DEAL_ROOM = "DEAL_ROOM";
export const EXPERIENCE_BENTO = "BENTO_GRID";
export const SHARE = "share";
export const COLLECTION = "collection";
export const LIST_VIEWER = "LIST_VIEWER";
export const IMMERSE_VIEWER = "IMMERSE_VIEWER";
export const GALLERY_VIEWER = "GALLERY_VIEWER";
